module.exports = __webpack_public_path__ + "img/horizontal_3_2_8019.1de1ea6a.png";